import { CONTACT_EMAIL } from "./contact";

export const LICENSING_LAST_UPDATED = "Last updated June 2026";

export const LICENSING_REQUEST_HREF = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent("Commercial licence enquiry")}`;

/**
 * Draft licensing agreement — not lawyer-reviewed.
 * Have qualified legal counsel review before relying on this in production.
 */
export const LICENSING_SUMMARY = [
  {
    key: "personal",
    icon: "check",
    title: "Personal use is fine",
    blurb:
      "Print it, frame it, hang it at home, set it as your wallpaper. Enjoy it however you like in your own space.",
  },
  {
    key: "commercial",
    icon: "alert",
    title: "Commercial use needs a yes",
    blurb:
      "Anything that promotes, sells, or earns — ads, products, clients, social channels — requires my written permission first.",
  },
  {
    key: "copyright",
    icon: "shield",
    title: "The copyright stays mine",
    blurb:
      "Buying a file or a print gives you a copy to enjoy — not the rights to the image. I remain the author and owner.",
  },
];
